namespace Portico.Services.Legacy {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    import ps = Portico.Services;

    import leg = Portico.Models.Legacy;
    import ent = Portico.Models.Enterprise;

    import lcs = Portico.Services.Legacy.CardService;
    import les = Portico.Services.Legacy.EnrollmentService;

    export interface IPorticoLegacyService {
        checkMN(memberNumber: string): angular.IPromise<IMemberNumberCodeResponse>;
		checkAnswer(surveyId: number, questionId: number, account: ent.Account): angular.IPromise<boolean>;
		checkAnswers(surveyIds: number[], questionIds: number[], account: ent.Account): angular.IPromise<boolean>;
        enroll(account: ent.Account, enrollment: ent.Enrollment): angular.IPromise<leg.EnrollmentResultModel>;
        enroll(account: ent.Account, enrollment: ent.Enrollment, programId: number): angular.IPromise<leg.EnrollmentResultModel>;
        enroll(account: ent.Account, enrollment: ent.Enrollment, programId?: number): angular.IPromise<leg.EnrollmentResultModel>;
    }

    export interface IMemberNumberCodeResponse extends leg.MemberNumberStatusResultModel{
        code: number;
    }
    export class MemberNumberCodeResponse extends leg.MemberNumberStatusResultModel{
        code: number;
        constructor(obj?: IMemberNumberCodeResponse){
            super();
            this.code = null;
            if(obj){
                this.code = obj.code || null;
            }
        }
    }

    @Service('app', 'porticoLegacyService')
    @Inject('$q',
        '$rootScope',
        '$state',
        'accountService',
        'dataService',
        'dateService',
        'LegacyCardService',
        'LegacyEnrollmentService',
        'surveyService')
    export class PorticoLegacyService implements IPorticoLegacyService {
        private serviceName: string = 'Portico.Services.Legacy.LegacyService';

        constructor(
            private $q: angular.IQService,
            private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private accountService: ps.IAccountService,
            private dataService: ps.IDataService,
            private dateService: ps.IDateService,
            private legacyCardService: lcs.LegacyCardService,
            private legacyEnrollmentService: les.LegacyEnrollmentService,
            private surveyService: ps.SurveyService
        ) { }

        checkMN(memberNumber: string): angular.IPromise<IMemberNumberCodeResponse> {
			if (this.dataService.session.mode === 'edit' || this.dataService.session.mode === 'mock') {
                return this.$q.when(new MemberNumberCodeResponse());
            }

            return this.legacyCardService.MemberNumberStatusApi.get(this.dataService.getProgramId(), memberNumber)
                .then((response: MemberNumberCodeResponse) => {
                    if (response.cardEndDate) {
                        if (this.dateService.isAfter(response.cardEndDate)) {
                            // expired
                            response.code = LegacyCheckMNCodes.Expired;
                        } else {
                            // already active
                            response.code = LegacyCheckMNCodes.Activated;
                        }
                    } else {
                        // inactive -> proceed
                        response.code = LegacyCheckMNCodes.Inactive;
                    }
                    return response;
                });
        }

		checkAnswer(surveyId: number, questionId: number, account: ent.Account): angular.IPromise<boolean> {
			if (this.dataService.session.mode === 'edit' || this.dataService.session.mode === 'mock') {
                return this.$q.when(true);
            }

            let mapper = new ps.Mappers.SurveyMapper();
			let surveySession = account.getSurveySession(surveyId);
            let answers = surveySession.getSurveySessionAnswers(questionId);
			let legacyQuestion = mapper.toLegacySurveyQuestion(surveySession.surveyId, questionId, answers[0]);

            return this.legacyEnrollmentService.VerifySurveyAnswerApi.post(this.dataService.getProgramId(), legacyQuestion)
                .then((response: leg.VerifySurveyEntryResultModel) => {
                    return response.isEligible;
                });
        }

		checkAnswers(surveyIds: number[], questionIds: number[], account: ent.Account): angular.IPromise<boolean> {
            let promises: angular.IPromise<boolean>[] = [];

			for (let i = 0; i < surveyIds.length; i++) {
				promises.push(this.checkAnswer(surveyIds[i], questionIds[i], account));
            }

            return this.$q.all(promises).then(x => x.every(z => z));
        }


        enroll(account: ent.Account, enrollment: ent.Enrollment): angular.IPromise<leg.EnrollmentResultModel>
        enroll(account: ent.Account, enrollment: ent.Enrollment, programId: number): angular.IPromise<leg.EnrollmentResultModel>
        enroll(account: ent.Account, enrollment: ent.Enrollment, programId?: number): angular.IPromise<leg.EnrollmentResultModel> {
			if (this.dataService.session.mode === 'edit' || this.dataService.session.mode === 'mock') {
				if (this.dataService.session.mode === 'mock') {
					this.dataService.session.intakeExpired = true;
                }

                enrollment.memberNumber = '00000000000';

                return this.$q.when(new leg.EnrollmentResultModel());
            }

            const mapper = new ps.Mappers.SurveyMapper();
			const requestModel = new leg.EnrollmentRequestModel();
			const accountSessions = account.accountSessions.filter((accountSession) => {
				return !accountSession.id && accountSession.surveySession;
			});
			const surveySession = accountSessions && accountSessions.length > 0 ? accountSessions[0].surveySession : null;

			requestModel.survey = mapper.toLegacy(surveySession);
            requestModel.demographics = mapper.toLegacyDemographics(account, enrollment.memberNumber);
            requestModel.clientIdentifiers = null;

            return this.legacyEnrollmentService.BasicEnrollmentApi.post(programId || this.dataService.getProgramId(), requestModel)
                .then((response: leg.EnrollmentResultModel) => {

                    enrollment.memberNumber = response.memberNumber;

                    return response;
                });
        }
    }

    export enum LegacyCheckMNCodes {
        Invalid = 0, // Failure. Invalid member number For program (success - false)
        Expired = 1, // Have to check the date with dateService.isAfter(cardEndDate) (success - true)
        Activated = 2, // Have to check the cardActivationDate!=null (success - true)
        Inactive = 3, // Have to check the cardActivationDate=null && cardEndDate=null? (succes - true)
        Error = 4 // Generic error response message is something like "an unknown error occurred" (success - false)
    }
}